import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationBundleService {
  // Dependencies
  private http = inject(HttpClient);

  /**
   * Fetch multiple translation bundles for a specific language.
   * Merges all key-value pairs into a single Record.
   */
  public getBundles(bundleNames: string[], languageId: string): Observable<Record<string, string>> {
    const requests = bundleNames.map(bundleName => {
      const bundleFileName = `public/i18n/${bundleName}.${languageId}.json`;
      return this.http.get<Record<string, string>>(bundleFileName).pipe(
        catchError(err => {
          console.warn(`Failed to load ${bundleFileName}`, err);
          return of({});
        }),
      );
    });

    return forkJoin(requests).pipe(
      map(results => {
        const merged: Record<string, string> = {};
        for (const bundle of results) {
          Object.assign(merged, bundle);
        }
        return merged;
      }),
    );
  }
}
